<template>
  <VisionSidebar
    :class="$b()"
    :max-width="600"
    :visible="visible"
    fixed-title
    @close="$emit('close-sidebar')"
  >
    <template #close-copy>
      {{ $tr('Continue Browsing.') }}
    </template>
    <template #customTitle>
      <div :class="$b('header')">
        <div :class="$b('header-rating')">
          <VisionStarRating
            :rating="reviewSummary.averageStars"
            colour="gradient"
          />
          <span
            v-if="reviewSummary.averageStars"
            :class="$b('header-rating-text')"
          >
            {{ $tn(reviewSummary.averageStars || 0, 1) }} / 5
          </span>
        </div>
        <div :class="$b('heading-wrapper')">
          <h3 :class="$b('heading-text')"> Customer Reviews </h3>
          <span :class="$b('heading-sub-text')">
            {{ $tn(reviewSummary.count || 0) }} verified customers
          </span>
        </div>
        <p :class="$b('heading-desc')">
          <strong>{{ $tp(reviewSummary.recommendRate || 0.995, 0, 1) }}</strong>
          would recommend to a friend.
        </p>
      </div>
    </template>
    <div :class="$b('body')">
      <FadeTransition>
        <InfiniteReviews
          v-if="visible"
          :use-generic-reviews="customisedProduct.product.useGenericReviews"
          :show-localised-reviews="false"
          :product-ids="productIds"
          :skus-for-reviews="skusForReviews"
          @current-slide-changed="currentSlide = $event"
          @review-product-clicked="handleReviewClick"
        />
      </FadeTransition>
    </div>
  </VisionSidebar>
</template>

<script>
import { storeToRefs } from 'pinia'
import CustomisedProduct from '~/models/CustomisedProduct'

export default {
  name: 'ReviewSidebar',

  props: {
    visible: { type: Boolean, default: false },
    customisedProduct: { type: CustomisedProduct, required: true },
    isCompositePdp: { type: Boolean, default: false },
    skusForReviews: { type: [Array, String], default: () => [] },
    productIds: { type: Array, default: () => [] },
    reviewSummary: { type: Object, default: () => ({}) },
    titleOverride: { type: String, default: '' },
  },

  emits: ['close-sidebar', 'review-clicked'],

  setup(props) {
    const store = useStorefrontStore()
    const { countryNameFromCode: getCountryName } = storeToRefs(store)

    const pageStore = usePageStore()

    if (props.visible) pageStore.toggleBlockBodyScroll(true)

    return {
      pageStore,
      getCountryName,
    }
  },

  computed: {
    country() {
      return this.getCountryName(this.storeCountry || 'GB')
    },
  },

  watch: {
    'props.visible'(newValue) {
      console.log('Is visible changed:', newValue)
    }
  },

  beforeUnmount() {
    this.pageStore.toggleBlockBodyScroll(false)
  },

  methods: {
    handleReviewClick(product) {
      this.$emit('review-clicked', product)
      this.$emit('close-sidebar')
    },
  }
}
</script>

<style lang="postcss" scoped>
.ReviewSidebar__body {
  @apply px-5 py-8;
}

.ReviewSidebar__heading-wrapper {
  @apply flex flex-wrap items-baseline gap-x-2 mb-1;
}

.ReviewSidebar__heading-text {
  @apply heading-3;
}

.ReviewSidebar__heading-sub-text {
  @apply text-xxs md:text-xxs;
}

.ReviewSidebar__heading-desc {
  @apply text-xxs;
}

.ReviewSidebar__header {
  @apply pt-6 pb-6 px-5;
}

.ReviewSidebar__header-rating {
  @apply mb-1;
}

.ReviewSidebar__header-rating-text {
  @apply text-xxs font-bold ml-1;
}
</style>
